import { DefaultValues } from "src/types";

export const defaults: DefaultValues = {
  username: "aabuhijleh",
  mode: "dark",
  soundEnabled: true,
  documentTitle: "",
  showWebsiteUrl: false,
};
